import { Check } from "lucide-react";
import { CtaButton } from "@/components/CtaButton";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { ValueStack } from "@/components/ValueStack";
import { site } from "@/config/site.config";

const checks = [
  "See the life you actually want",
  "Choose it — without editing your desire",
  "Create your personal Vision Blueprint",
  "Install the 7 Quantum Habits™ daily rituals",
  "Expand your capacity to hold more life",
  "Turn what’s inside you into something real",
  "Receive the experience + three digital books",
  "Bonus: The Blueprint + 7 Daily Rituals programs",
  "Get instant digital access",
];

export const FinalOffer = () => (
  <section data-testid="final-offer-section" className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
    <Reveal className="mb-12 text-center">
      <Eyebrow>YOUR NEXT MOVE</Eyebrow>
      <h2 className="mt-4 text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
        THE DOOR IS OPEN.
        <br />
        <span className="font-serif italic font-medium text-lime">WALK THROUGH IT.</span>
      </h2>
    </Reveal>

    <Reveal>
      <div data-testid="final-offer-card" className="mx-auto max-w-2xl bg-paper p-8 text-ink shadow-[0_50px_100px_rgba(0,0,0,0.5)] sm:p-12">
        <p className="font-serif text-3xl italic sm:text-4xl">{site.productName}</p>
        <p className="mt-2 font-mono text-[11px] tracking-[0.35em] text-ink/60">THE COMPLETE VISION EXPERIENCE</p>
        <p className="mt-4 font-mono text-[11px] tracking-[0.35em] text-ink/60">
          PLUS: <span className="font-bold text-ink">3 DIGITAL BOOKS + 2 BONUS PROGRAMS</span>
        </p>

        <div className="mt-8 flex items-end gap-4">
          <span data-testid="final-price" className="font-serif text-8xl font-bold leading-none">{site.price}</span>
          <span className="pb-2 font-mono text-[11px] tracking-[0.3em] text-ink/60">ONE-TIME PAYMENT</span>
        </div>

        <ul className="mt-8 grid gap-x-6 gap-y-3 sm:grid-cols-2">
          {checks.map((c) => (
            <li key={c} className="flex items-start gap-2.5 text-sm font-semibold">
              <Check className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={3} />
              {c}
            </li>
          ))}
        </ul>

        <ValueStack dark />

        <CtaButton id="final" variant="dark" className="mt-10 w-full !text-base">
          ENTER WILD WOMAN MILLIONS — {site.price}
        </CtaButton>
        <p className="mt-4 text-center font-mono text-[10px] tracking-[0.25em] text-ink/50">
          INSTANT ACCESS · ONE PAYMENT · FULLY DIGITAL
        </p>
      </div>
    </Reveal>

    <Reveal className="mx-auto mt-14 max-w-xl text-center">
      <p className="font-serif text-xl italic leading-relaxed text-cream/80 sm:text-2xl">
        Your ideas do not need to die inside you. See it. Choose it. Practice it. Hold it. Live it.
      </p>
    </Reveal>
  </section>
);
